$(document).ready(function () {
  const comparatorModal = document.querySelector(".comparator-modal")
  const comparatorMenuItem = document.querySelector(".menu-item-comparator a")
  const comparatorButton = document.getElementById('comparator-button')
  const modalButtonSearch = document.querySelector(".comparator-modal .button-search")
  const modalButtonShowCars = document.querySelector(".comparator-modal .button-show-cars")
  const urlCompare = document.getElementById("urlCompare").value
  localStorage.setItem('urlCompare', urlCompare)

  if (modalButtonSearch) {
    modalButtonSearch.addEventListener('click', () => {
      window.location.href = ajax_filter_params.comparator_search_url;
    })
  }

  if (modalButtonShowCars) {
    modalButtonShowCars.addEventListener('click', () => {
      const carsStatus = document.querySelector(".comparator-modal .cars").classList.toggle("cars-hidden")
      if (carsStatus) {
        modalButtonShowCars.innerHTML = "Mostrar"
      } else {
        modalButtonShowCars.innerHTML = "Ocultar"
      }
    })
  }

  if (comparatorButton) {
    const post_id = comparatorButton.getAttribute('versionid')
    comparatorButton.addEventListener('click', (ev) => {
      toggleCarFromComparator(post_id)
      ev.preventDefault()
    })
  }

  if (comparatorMenuItem && comparatorModal) {

    comparatorMenuItem.addEventListener('click', (ev) => {
      const status = comparatorModal.classList.toggle('comparator-modal-hidden')
      if (status) {
        comparatorMenuItem.classList.remove('modal-on')
      } else {
        comparatorMenuItem.classList.add('modal-on')
      }
      ev.preventDefault();
    })
  }

  if (comparatorModal) {
    comparatorModal.querySelector(".button-clear-comparator")
    .addEventListener("click", ev => {
      setComparatorStorage([]);
      updateComponents();
    })
    comparatorModal.querySelector(".button-compare")
      .addEventListener("click", goToComparator)
  }

  updateComponents()

})

function goToComparator() {
  const data = getComparatorStorage();
  const ids = data.map(car => car.ID).join(",")
  window.location.href = `/${localStorage.getItem('urlCompare')}/?ids=${ids}`
}

function getComparatorStorage() {

  if (!localStorage.getItem('comparador')) {
    localStorage.setItem('comparador', "[]")
  }
  const comparatorStorage = JSON.parse(localStorage.getItem('comparador'))
  return cleanData(comparatorStorage)

}

function setComparatorStorage(data) {

  localStorage.setItem('comparador', JSON.stringify(
  cleanData(data)
  ))

}

function cleanData(data) {

  return data.filter(item => {
    return typeof item === 'object' && item != null
  })

}

function removeCarFromComparator(id) {

  setComparatorStorage(
  getComparatorStorage()
  .filter(car => car.ID != id)
  )
  updateComponents();

}

function addCarToComparator(id) {

  const comparatorStorage = getComparatorStorage();

  if (comparatorStorage.length > 3) {
    alert("Lo sentimos, haz alcanzado el máximo de autos admitidos en el comparador.\nPor favor, elimina un vehículo para agregar una nueva unidad")
    updateComponents();
    return
  }

  getCarFromAjax(id)
  .then(newCar => {
    comparatorStorage.push(newCar)
    setComparatorStorage(comparatorStorage)
    updateComponents()
  })

}

function updateComponents() {

  const comparatorStorage = getComparatorStorage();
  updateComparatorButton(comparatorStorage)
  updateComparatorModal(comparatorStorage)
  updateComparatorButtonFromCards(comparatorStorage)


}

function toggleCarFromComparator(postID) {

  var comparatorModal = $('.comparator-modal');

  if( comparatorModal.hasClass('comparator-modal-hidden')){
    comparatorModal.removeClass('comparator-modal-hidden');
  }

  const comparatorStorage = getComparatorStorage();
  if (comparatorStorage.some(car => car.ID == postID)) {
    console.log('remove car to comparator:' + postID);
    removeCarFromComparator(postID);
  } else {
    console.log('add car to comparator:' + postID);
    addCarToComparator(postID)
  }
}

function updateComparatorButton(comparatorStorage) {

  const comparatorButton = document.getElementById('comparator-button')
  if (!comparatorButton) {
    return
  }

    const btnCompare = document.getElementById('comparatorButtonText')
  if (comparatorStorage.some(car => car.ID == comparatorButton.getAttribute('versionid'))) {
    btnCompare.innerHTML = 'Quitar'
  } else {
    btnCompare.innerHTML = 'Agregar'
  }

}

function getCarFromAjax(postID) {

  return fetch(ajax_filter_params.ajax_url + `?action=get_post_from_ajax&post_id=${postID}`,
  {
    method: "POST",
  })
  .then((response) => response.json())
  .then((response) => {
    return response.car;
  })
  .catch(error => console.warn(error));

}

function updateComparatorModal(comparatorStorage) {

  const comparatorModal = document.querySelector(".comparator-modal")
  const carsBox = comparatorModal.querySelector(".cars")
  const carsQuantity = comparatorModal.querySelector(".car-quantity")
  const modalButtons = comparatorModal.querySelectorAll(".button-compare, .button-clear-comparator, .button-show-cars")
  const modalButtonSearch = comparatorModal.querySelectorAll(".button-search")
  const modalButtonShowCars = comparatorModal.querySelector(".button-show-cars")

  if (!carsBox) {
    return
  }

  if (comparatorStorage.length == 0) {
    comparatorModal.classList.add('comparator-modal-emtpy')
    carsBox.classList.add('hidden')
    modalButtons.forEach(item => item.classList.add("hidden"))
    modalButtonSearch.forEach(item => item.classList.remove("hidden"))
    modalButtonShowCars.innerHTML = "Mostrar"
  } else {
    comparatorModal.classList.remove('comparator-modal-emtpy')
    carsBox.classList.remove('hidden')
    modalButtons.forEach(item => item.classList.remove("hidden"))
    modalButtonSearch.forEach(item => item.classList.add("hidden"))
    modalButtonShowCars.innerHTML = "Ocultar"
  }

  carsBox.innerHTML = ""
  carsQuantity.innerHTML = comparatorStorage.length
  comparatorStorage.forEach(car => {
    carsBox.append(getCarModalElement(car))
  })

}

function getCarModalElement(car) {

  const carElement = document.createElement("div")
  const carImage = (car.image) ? `<img src="${car.image}" alt="Imagen del auto">`:'<img src="/wp-content/themes/ces/img/auto-1.png" alt="Imagen del auto">';

  carElement.innerHTML =
  `<i class="icon-cerrar-1"></i>
    ${carImage}
    <div class="car-info">
      <div class="brand">${car.brand}</div>
      <div class="model">${car.model}</div>
      <div class="version">${car.version_name}</div>
    </div>`
  carElement.dataset.id = car.ID
  carElement.classList.add("car")
  carElement.querySelector('.icon-cerrar-1')
  .addEventListener('click', (ev) => {
    removeCarFromComparator(car.ID)
  })

  return carElement

}

function updateComparatorButtonFromCards(comparatorStorage) {

  const $cards  = $('.item-card')

  $cards.each(function(index,element){
    const $card = $(this);
    const $comparatorActions = $card.find('.comparator-actions')
    const id = $comparatorActions.data('id');

    const $addContainer = $comparatorActions.find('.add')
    const $removeContainer = $comparatorActions.find('.remove')

    let buttonInComparator = comparatorStorage.some(car => car.ID == id)

    if (buttonInComparator) {
      //console.log({id,comparatorStorage})
      $addContainer.addClass('hide')
      $removeContainer.removeClass('hide')

    } else {
      $addContainer.removeClass('hide')
      $removeContainer.addClass('hide')
    }

  });
/*
  (card => {

    let buttonId = button.dataset.id

    button.disabled = false;
    if (buttonInComparator) {
      //buttonText.innerHTML = "Quitar"
      button.dataset.inComparator = true
    } else {
      //buttonText.innerHTML = "Comparar"
      button.dataset.inComparator = false
    }
  })
*/

  const buttons = document.querySelectorAll(".compare-from-card")

  buttons.forEach(button => {
    let buttonId = button.dataset.id
    let buttonInComparator = comparatorStorage.some(car => car.ID == buttonId)
    button.disabled = false;
    if (buttonInComparator) {
      //buttonText.innerHTML = "Quitar"
      button.dataset.inComparator = true
    } else {
      //buttonText.innerHTML = "Comparar"
      button.dataset.inComparator = false
    }
  })

}

/* Show comparator */
document.addEventListener("DOMContentLoaded", function () {

  if (window.location.pathname != '/comparador/') {
    return
  }

  const ids = [...new Set(findParameter('ids', window.location)
  .split(',')
  .filter(id => /^\d+$/.test(id))
  )]

  ajaxVersion(ids)


})

function findParameter(name, url) {
  const direction = new URL(url || location.href)
  return direction.searchParams.get(name)
}

function isCompare() {
  if (!localStorage.getItem('comparador')) return false
  if (!JSON.parse(localStorage.getItem('comparador')).length) return false
  return true
}

function ajaxVersion(ids) {
  $('#loading').show();
  $.ajax({
    type: 'post',
    url: ajax_filter_params.ajax_url,
    data: {
      action: 'get_versions_compare',
      ids: ids
    },
    error: function (response) {
      console.error("comparator.js: ", response)
      showComparator([])
    },
    success: function (response) {
      showComparator(response, response.pageSearch)
      $('#loading').hide();
    }
  })

}

function showComparator(cars, pageSearch) {

  addTitleCompare(cars.versions)
  addCardVersions(cars, pageSearch)
  displayDataCompareTable(cars.table)
}

//Show info in table specs
function displayDataCompareTable(specs) {
    const accordion = document.getElementById('accordion')
    if (!accordion) {
      return
    }
    specs.forEach(spec => {
      var rows = displayRows(spec.rows, spec.categoryId ? 'row'+spec.categoryId+'tbodySpecs' : 'rowPricestbodySpecs', spec.categoryName)
      var html = ` <div class="card collapsed" data-toggle="collapse" data-target="#${spec.categoryId ? 'row'+spec.categoryId : 'rowPrices'}" aria-expanded="true" aria-controls="${spec.categoryId ? 'row'+spec.categoryId : 'rowPrices'}">
          <div class="spec-header">
            <span>${spec.categoryName}</span><i class="icon-arrowDown"></i>
          </div>
          <div id="${spec.categoryId ? 'row'+spec.categoryId : 'rowPrices'}" class="collapse__body collapse specs-list" aria-labelledby="heading1" data-parent="#accordion">
            <div class="collapsible-body">
              <table>
                <tbody id="${spec.categoryId ? 'row'+spec.categoryId+'tbodySpecs' : 'rowPricestbodySpecs'}">
                  ${rows}
                </tbody>
              </table>
            </div>
          </div>
        </div>`
      accordion.insertAdjacentHTML( 'beforeend', html )
    });
}

function displayRows(rows, id, type){

    var rowsHtml = '';
    rows.forEach((row, key) => {
      var columns = displayColumns(row.columns, id+key+'trSpecs', type)

      rowsHtml+= `<tr id="${id+key}trSpecs"> ${columns} </tr>`;
    });
    return rowsHtml;
}

function displayColumns(columns, id, type){
    var columnsHtml =''
    columns.forEach((column, index) => {
      var value = column.value ? isPrecioLista(column.value, type, index) : 'N/A';

      columnsHtml+=`<td id="tdSpecs" class="my-auto">
        <div class="value"> ${value} </div> 
      </td>`

    });
    return columnsHtml;
}

function isPrecioLista(value, type, index){
  if(type == 'Precios' && index != 0){
    if(value) {
      return value = Intl.NumberFormat("en-us", { style: "currency", currency: "USD", minimumFractionDigits: 0 }).format(value).replace(',', '.').replace(',', '.').replace('$', '$ ');
    } else {
      return ''
    }
  }{
    return value
  }
}

function addCardVersions(cars, pageSearch) {
  rowCardVersion = document.querySelector('.comparator-versions')
  if (!rowCardVersion) {
    return
  }

  rowCardVersion.insertAdjacentHTML('afterbegin', `
    <div class="first-card">
      <p>Cotiza en Dercocenter la más amplia variedad de vehículos a tu elección.</p>
    </div>
  `)
  let cantEmpty = 0
  cars.versions.forEach((car, index) => {
    if (Object.keys(car).length === 0 ) {
      cantEmpty++
      return
    }
    const specialSale = car.isSpecialSale ? `<div class="special-sale"><span>${car.specialSalePercentage}%</span>DCTO</div>` : "";
    rowCardVersion.insertAdjacentHTML('beforeend',
    `<div class="version-card ${car.isSpecialSale ?? "with-special-sale"}">        
        <div class="model font-weight-bold">${car.model.name} <span class="version"> ${car.name} </span></div>
        <div 
          class="close" 
          onclick="removeItemComparator(${car.id})"
          title="Eliminar item: ${car.model.name} ${car.name}"
          ><i class="icon-CerrarModal"></i>
        </div>
        <img class="car-image" src="${car.image.url}" title="" alt="${car.model.name} ${car.name}">
        <div class="price">
          <div class="list-price">Precio Normal <span class="price-value">${car.prices[0]['value']}</span></div>
          <div class="min-price price-value ${specialSale ? 'text-left' : ""}">
            &#36;${"$" + car.minPrice}
          </div>
          ${specialSale}
        </div>
        <a href="/cotizar/?v=${car.id}" class="quote">Cotizar</a>
      </div>`)
  })

  for (let index = 1; index <= cantEmpty; index++) {
    rowCardVersion.insertAdjacentHTML('beforeend', `
      <a class="add-car" href="/${pageSearch}">Agregar vehículo</a>
    `)
  }
}

function addTitleCompare(cars) {
  const header = document.querySelector('.comparator-header')
  if (!header) {
    return
  }

  const headerText = cars.map(car => {
    return car.name
  })

  const comparedCars = []

  headerText.forEach(car => {
    if (car != undefined) {
      comparedCars.push(car)
    }
  });

  header.insertAdjacentHTML('beforeend',
  `<h1>
      <span>Comparando: </span>${comparedCars || "no has seleccionado versiones para comparar."}
  </h1>`)

}

function removeItemComparator(id) {

  removeCarFromComparator(id)
  const ids = JSON.parse(localStorage.getItem('comparador')).map(car => car.ID)
  window.location.href = `/${localStorage.getItem('urlCompare')}`+'/?ids=' + ids.join(",")

}


